// YAYA mascot illustrations — transparent PNGs (friendly owl coach, navy + orange, graduation cap)
export const MASCOT = {
  wave: "/mascots/wave.png",
  book: "/mascots/book.png",
  point: "/mascots/point.png",
  celebrate: "/mascots/celebrate.png",
  encourage: "/mascots/encourage.png",
  rocket: "https://static.prod-images.emergentagent.com/jobs/6c4e6cfe-6476-4c58-a445-e26eeecbd2f3/images/1beca57986f5c245f8f27ba6a17ec70e6fc4d971737f6a84f7806838ad571ae8.jpeg",
};
